import {  legacy_createStore as createStore, applyMiddleware, compose, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import resourceReducer from './resource/resource.reducer';
import codeReducer from './coding/code.reducer';
import testReducer from './test/test.reducer';
import AuthReducer from './authentication/auth.reducer'
import profileReducer from './profile/profile.reducer';
import { chatReducer } from './chat/chat.reducer';
import { flashcardsReducer } from './flashcards/flashcards.reducer';
import teacherProfileReducer from './Teacher_Panel/Teacher_profile/profile.reducer';
import createResourceReducer from './Teacher_Panel/Teacher_Resource/resource.reducer';
import analyticsReducer from './analytics/analytics.reducer';
import peopleReducer from './Admin_Panel/people/people.reducer';
import catPaperReducer from './Teacher_Panel/cat_paper/cat.reducer';
import reportReducer from './Teacher_Panel/report/report.reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
    ResourceManager: resourceReducer,
    CodeManager: codeReducer,
    TestManager: testReducer,
    AuthManager: AuthReducer,
    ProfileManager: profileReducer,
    ChatManager: chatReducer,
    FlashCardsManager: flashcardsReducer,
    TeacherProfileManager: teacherProfileReducer,
    CreateResourceManager: createResourceReducer,
    AnalyticsManager: analyticsReducer,
    AdminPeopleManager: peopleReducer,
    catPaperManager: catPaperReducer,
    reportManager: reportReducer
  });

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk)
  )
);

